module.exports = ol.layer.VectorTile;